import React from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { BackdropProps } from './models';
import classNames from 'classnames';

export const Backdrop = styled(({ className, children }: BackdropProps) => {
  return (
    <div className={classNames(className, 'backdrop')}>
      <div {...{ className: 'backdrop-layer' }} />
      {children}
    </div>
  );
})`
  ${styles.Backdrop}
`;
